export default __webpack_public_path__ + "static/media/fedex-marked.3c6dcc7f.png";